import { render } from "./knowledge.vue?vue&type=template&id=07853400&scoped=true"
const script = {}

import "./knowledge.vue?vue&type=style&index=0&id=07853400&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07853400"]])

export default __exports__